import {
  Component,
  Renderer2,
  Inject,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormGroupDirective,
} from "@angular/forms";
import { environment as ENV } from "../../../environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddCustomerService } from "./add-customer.service";
import { ManageAdminsService } from "../manage-admins/manage-admins.service";
import {
  ACCOUNT_TYPE,
  APPLICATION_TYPE,
  APPLY_FOR,
  CUSTOMER_TYPE,
  CUST_LOAN_TYPE,
  EDUC_LOAN_SUB_TYPE,
  EXIST_OR_NEW,
  LAP_SUB_TYPE,
  LOAN_CUSTOMER_TYPE,
  INDIV_OR_NONINDIV,
  NONINDIVIDUAL_TYPE,
  MSME,
  RETAIL_AG_SECUIRTY,
  RETAIL_DEPOSIT,
  RETAIL_EDUC_LOAN,
  RETAIL_GOLD_LOAN,
  RETAIL_HOME_LOAN,
  RETAIL_HOME_UPGRADE,
  RETAIL_LAP_OVERDRAFT,
  RETAIL_LOAN_AG,
  RETAIL_PERSONAL_LOAN,
  RETAIL_STAFF_LOAN,
  RETAIL_VEHICLE_LOAN,
  VEHICLE_SUB_TYPE,
  MACHINERY_TYPE,
  VEHICLE_SUB_TYPE_1,
  VEHICLE_SUB_TYPE_2,
  VEHICLE_SUB_TYPE_3,
  VEHICLE_SUB_TYPE_4,
  VEHICLE_SUB_TYPE_6,
  VEHICLE_SUB_TYPE_5,
  AGRI_LOAN_TYPE,
  SEGMENT,
  AGRI_KCC_PRODUCT_TYPE,
  AGRI_MSME_LOAN_TYPE,
  AGRI_OTHERS_PRODUCT_TYPE,
  PROFILE_TYPE, COOPS_IND_Type, COOPS_NONIND_Type, FORM_DETAILS, LOAN_TYPE_APCOB, MORTGAGE_LOAN_TYPE, TRADER_LOAN_TYPE,
  LOAN_TYPE_APCOB_SALPEN, MORTGAGE_LOAN_TYPE_SALPEN, TRADER_LOAN_SUB_TYPE, APCOB_GOLD_LOAN_TYPE,SOD_SUB_TYPE,LARP_SUB_TYPE,SML_SUB_TYPE
} from "./add-customer-constant";
import { Observable } from "rxjs";
import * as constants from "../../constant";
import { Router } from "@angular/router";
import { ApplicantService } from "../../applicant.service";

@Component({
  selector: "wl-add-customer-new",
  templateUrl: "./add-customer-new.component.html",
  styleUrls: ["./add-customer-new.component.scss"],
  providers: [AddCustomerService],
})
export class AddCustomerNewComponent implements OnInit {
  applyType: any = APPLY_FOR;
  exisORNew = EXIST_OR_NEW;
  joinORIndiviuals = CUSTOMER_TYPE;
  accountTypes = ACCOUNT_TYPE;

  customerType = LOAN_CUSTOMER_TYPE;
  profileType: any;
  // indivORNonIndiv = INDIV_OR_NONINDIV;
  indivORNonIndiv = ENV.INDIV_OR_NONINDIV;
  nonIndivType = NONINDIVIDUAL_TYPE;
  nonind = ENV.NONINDIVIDUAL_TYPE;
  loanType = CUST_LOAN_TYPE;
  selectedCustomerType: any = [];
  selectedLoanType: any = [];
  selectedNonIndivType: any = [];
  selectedsegment: any = [];
  yesorNo = FORM_DETAILS;

  msme = MSME;
  agri_loan = AGRI_LOAN_TYPE;
  isProducthide: boolean;
  isNonIndiviShown: boolean = false;
  isSegmentShown: boolean = false;
  selectedProduct: any = [];
  inputTitlePrefix = "Customer";
  isMinorSelected: boolean = false;
  isDataPending: boolean;
  vehicleSubTypes: any[];
  segmentId: any;
  segment = SEGMENT;
  categoryData: any;
  typeId: any;
  appID: any;
  id: string;
  coopsIndType = COOPS_IND_Type;
  coopsNonIndType = COOPS_NONIND_Type;
  apcobLoanType = LOAN_TYPE_APCOB;
  mlSubLoanType: any;
  apcobMortgageLoanType = MORTGAGE_LOAN_TYPE;
  apcobTraderLoanType = TRADER_LOAN_TYPE;
  apcobGoldLoanType = APCOB_GOLD_LOAN_TYPE;
  apcobSodSubType = SOD_SUB_TYPE;
  apcobLarpSubType = LARP_SUB_TYPE;
  apcobSmlSubType = SML_SUB_TYPE;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;
  showOpenAccountForm: boolean = false;
  showLoanAccountForm: boolean = false;

  customerForm: FormGroup;
  commonForm: FormGroup;
  loanForm: FormGroup;
  loanForms: FormGroup;

  countValue: any;
  isDataFetchCompleted = false;
  isCustAvailable = false;
  subProductType = "";
  showSubProductType: boolean = false;
  loanSubProdType = [];
  errorLineMinor: boolean;
  errorLineEntity: boolean = false;
  showSpinner: boolean;
  custId: any;
  loanCustID: any;
  custEmail: any;
  custType: any;
  category: Observable<any>;
  showOtherField: boolean;
  disableSubmit: boolean;
  type: any;
  custProfile: any;
  Razorpay: any;
  orderId: string;
  disablePay: boolean;
  disablePayWithRazor;
  df: boolean;
  fc: boolean;
  mp: boolean;
  payment: boolean;
  selfJourney: boolean;
  isPanAllowed: boolean;
  isPanVerified: boolean;
  isPanRequired: boolean;
  isDisableSubmit: boolean;
  showAddCustomer: boolean = true;
  showExistingCustomerName: boolean;
  customerName: any;
  profileId: any;
  project: string;
  mobileNumber: string;
  existAcc: boolean;
  ageErrorMessage: string;
  subLoanType: { id: number; type: string; name: string; }[];
  apcobProject: boolean;
  subLoanTypeRequired: boolean;
  existingCustValidated: boolean;
  existCustAcc: boolean;
  existingCustAccValidated: boolean;
  disableValidation: boolean;
  existWorkAcc: boolean;
  loanAmountErrorMessage: string;
  loanTenureErrMessage: any;
  typeOfCustomer: any;
  existingApcobStaff: boolean;
  distanceErrMessage: string;
  selectedApcobLoanType: any;
  selectedApcobSubLoanType: any;
  selectedApcobSalaryAccount: any;
  selectedApcobITR: any;
  selectedApcobGuarantor: any;
  personalLoan: boolean = false;
  mortgageLoan: boolean = false;
  personalItr: boolean;
  sodItr: boolean;
  lreItr: boolean;
  ccItr: boolean;
  subTraderLoanType: { id: number; type: string; name: string; }[];
  ssuf: boolean;
  traderLoanSubType: any;
  apcobSubLoanType: string;
  existingCustomer: any;
  isotherType: boolean = false;
  isexistingCustomer: boolean = false;
  traderLoan: boolean;
  projectName: string = ENV.projectName;
  subLoanOptions: any[] = [];
  application_type: any;
  roleId: any;
  profileName: string;
  mortgageLoanChange: any;
  guarantorRequired: boolean ;
  collateralSecurity: boolean;
  collateralSecurityValue: any;

  fpoBranches: any[] = [];
  tenureDisable: boolean;

  constructor(
    private fb: FormBuilder,
    private cust: AddCustomerService,
    private router: Router,
    private snackbar: MatSnackBar,
    private applicant: ApplicantService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private manageAdmins: ManageAdminsService
  ) {
    this.loanForm = this.fb.group({
      entityType: [""],
      loanCustType: ["",],
      fpoName: [""],
      loanCustName: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      customerTypes: ["", Validators.required],
      assignedTo: [""],
      existingCust: [""],
      existingAcc: [""],
      workAcc: [""],
      salaryAccount: [""],
      age: [""],
      loanType: [""],
      loanSubType: [""],
      traderLoanSub: [""],
      loanAmount: [""],
      tenure: [""],
      existingStaff: [""],
      propertyDist: [""],
      itrFilled: [""],
      guarantor: [""],
      othersType: [""],
      accountNumber: [""],
       mortLoan:[""],
      marAmount:[""],
      loanCustEmail: [
        "",
        [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")],
      ],
      loanCustMobNum: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"),
        ]),
      ],
      panNo: [
        "",
        Validators.compose([
          // Validators.required,
          // Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/),
        ]),
        
      ],
       collateralSecurity: [""], // need to configure properly.
       ageOfProperty: [""], 
      // applicationType: [""],
      // profileId: [""],
      // name: ["", [Validators.required]],
      // email: ["", [Validators.email]],
      // mobileNo: ["", [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      // resAdd: [""],
      // offadd: [""],
      // office: [""],
    });
    this.loanForms = this.fb.group({
      applicationType: [""],
      loanType: [""],
      profileId: [""],
      name: ["", [Validators.required]],
      email: ["", [Validators.email]],
      mobileNo: ["", [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      resAdd: [""],
      offadd: [""],
      office: [""],
     
     
    });
  }

  ngOnInit() {
    this.loanForm.get('customerTypes').valueChanges.subscribe(value => {
       if (value == this.indivORNonIndiv[0]?.type && this.projectName !== 'vkf'  ) {
         this.profileType = ENV.LOAN_CUSTOMER_TYPE;
        this.loanForm.patchValue({ loanCustType: '', entityType: '' });
      } else if (value == this.indivORNonIndiv[1]?.type && this.projectName !== 'vkf'  ) {
         this.profileType = this.nonIndivType
    this.loanForm.patchValue({ loanCustType: '', entityType: '' });
      } 
    });

    this.cust.getApplicationTypes().subscribe(data => {
      this.application_type = data;
    });

    if (sessionStorage.getItem("custselfjourney") == "custselfjourney") {
      this.selfJourney = true;
      // this.verifyPayment();
    } else if (sessionStorage.getItem("custselfjourney") == "assistedjourney") {
      this.selfJourney = false;
    }

    // this.addPaymentForm();
    this.type = ENV.profileType;
    // this.profileType = LOAN_CUSTOMER_TYPE;
    this.profileType = ENV.LOAN_CUSTOMER_TYPE;
    this.custProfile = ENV.custType;
    this.isPanRequired = ENV.panRequired;
    this.project = ENV.projectName;
    this.mobileNumber = sessionStorage.getItem("mobileNumber");
    this.customerName = sessionStorage.getItem('name');

    this.roleId = sessionStorage.getItem("roleId");
    
    this.project === "dfid" ? this.profileName = "Create My" : this.profileName = "Add";

    if (this.project === "apex") {
      this.loanForm.controls["panNo"].setValidators([
        Validators.required,
        Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/),
      ]);
      // this.isDisableSubmit = true;
    } else if (this.project === "dfid" || this.project === "finnid" && this.roleId == 4 || this.project === "sahyadarifarms" && this.roleId == 4) {
        this.loanForm.patchValue({ loanCustName: this.customerName, loanCustMobNum: this.mobileNumber})
    } else if (this.project === "apcob") {

      this.apcobProject = true;
      this.loanForm.controls["existingCust"].setValidators([Validators.required]);
      //  this.loanForm.controls["salaryAccount"].setValidators([Validators.required]);
      this.loanForm.controls['loanType'].setValidators([Validators.required]);
      // this.loanForm.controls['itrFilled'].setValidators([Validators.required]);
      // this.loanForm.controls['guarantor'].setValidators([Validators.required]);
      this.indivORNonIndiv = ENV.INDIV_OR_NONINDIV;
      this.loanForm.patchValue({ customerTypes: "Individual" })
      //  this.loanForm.controls["existingAcc"].setValidators([Validators.required]);
      this.loanForm.controls['loanCustType'].valueChanges.subscribe(value => {
        console.log(value)
        if (value == this.profileType[2].type) {
          this.loanForm.controls['age'].setValidators([Validators.required, Validators.min(18), Validators.max(65)]);
          this.loanForm.controls['age'].updateValueAndValidity();
          this.ageErrorMessage = "Age of the pensioner should be between 18 and 65 years";

        } else if (value == this.profileType[0].type || value == this.profileType[1].type || value == this.profileType[3].type || value == this.profileType[4].type) {

          this.loanForm.controls['age'].setValidators([Validators.required, Validators.min(18), Validators.max(62)]);
          this.loanForm.controls['age'].updateValueAndValidity();
          this.ageErrorMessage = `Age of the ${value} should be between 18 and 62 years`;
        } else {

          this.loanForm.controls['age'].setValidators([Validators.required]);
          this.loanForm.controls['age'].updateValueAndValidity();
        }
      })
      this.loanForm.controls['loanAmount'].valueChanges.subscribe(value => {

         let loanAmount = this.loanForm.get("loanAmount").value;
         let loanType = this.loanForm.get('loanType').value;

        if (this.traderLoanSubType !== TRADER_LOAN_SUB_TYPE[0].type && loanType == LOAN_TYPE_APCOB[2].type) {
          
          if(loanAmount <= 200000){

            this.loanTenureErrMessage = `Loan Tenure cannot be more than 24 months.`
            this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(24)]);
          } else if(loanAmount > 200000 && loanAmount <= 300000){
            this.loanTenureErrMessage = `Loan Tenure cannot be more than 48 months.`
            this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(48)]);
          } else if(loanAmount > 300000 && loanAmount <= 500000){
            this.loanTenureErrMessage = `Loan Tenure cannot be more than 60 months.`
            this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(60)]);
          }
      
    } 
      })
    } else if (this.project == "moneyboxx") {
      this.loanForm.patchValue({ customerTypes: "Individual", loanCustType: "Farmer Agri" })
    } else {
      this.indivORNonIndiv = ENV.INDIV_OR_NONINDIV;
      this.isDisableSubmit = false;
    }

    if (this.project != "apcob") {
      this.loanForm.controls["customerTypes"].valueChanges.subscribe((value) => {
        console.log(value);
        if (value == "1") {
          this.errorLineEntity = false;
          this.loanForm.controls["entityType"].clearValidators();
          this.loanForm.controls["entityType"].updateValueAndValidity();
        } else if (value == "2") {
          this.errorLineEntity = true;
          this.loanForm.controls["entityType"].setValidators([
            Validators.required,
          ]);
          this.loanForm.controls["entityType"].updateValueAndValidity();
        }
      });
    } else {

    }
  }

  onCustTypeChange(event: any) {
    console.log("in if---------->", event);
    this.typeOfCustomer = event.value;

    if (this.projectName === 'sahyadarifarms' && event.value === 'Farmer Agri' ||
      this.projectName === 'Whatsloan_marketplace' && event.value === 'Farmer Agri'
    ) {
      this.loadFpoBranches();
    }

    if (event.value == this.customerType[3].type) {
      this.isProducthide = false;
      this.loanForm.get("loanProduct")?.setValidators(Validators.required);
      this.selectedLoanType = CUST_LOAN_TYPE;
      console.log("in if---------->", this.selectedLoanType);
    } else if (event.value == this.customerType[2].type) {
      this.isProducthide = false;
      this.loanForm.get("loanProduct")?.setValidators(null);
      this.selectedLoanType = MSME;
      console.log("in else if---------->", this.selectedLoanType);
    } else if (event.value == this.customerType[0].type) {
      this.isProducthide = true;
      this.loanForm.get("loanProduct")?.setValidators(null);
      this.selectedLoanType = AGRI_LOAN_TYPE;
      this.apcobLoanType = LOAN_TYPE_APCOB_SALPEN;
      console.log("in else if---------->", this.selectedLoanType);
    } else if (event.value == this.customerType[1].type) {
      this.isProducthide = false;
      this.loanForm.get("loanProduct")?.setValidators(null);
      this.selectedLoanType = AGRI_MSME_LOAN_TYPE;
      this.apcobLoanType = LOAN_TYPE_APCOB;
      console.log("in else if---------->", this.selectedLoanType);
    } else if (event.value == this.profileType[2].type) {
      this.isProducthide = true;
      this.apcobLoanType = LOAN_TYPE_APCOB_SALPEN;
      // this.ageErrorMessage = "Age of the pensioner should be below 65 years";
    } else if (event.value == this.profileType[1]?.type) {
      this.isProducthide = false;
      this.apcobLoanType = LOAN_TYPE_APCOB;
      // this.ageErrorMessage = "Age of the pensioner should be below 65 years";
    } else if (event.value == this.profileType[4]?.type) {
      this.isProducthide = false;
      this.apcobLoanType = LOAN_TYPE_APCOB;
      this.isotherType = true;
      this.loanForm.get("othersType")?.setValidators(Validators.required);
    } else {
      this.apcobLoanType = LOAN_TYPE_APCOB;
      // this.ageErrorMessage = "Age should be between 18 and  62 years";
    }
  }

  loadFpoBranches() {
    const adminId = sessionStorage.getItem("adminId") || "";
    this.manageAdmins.fetchLocations(adminId).subscribe({
      next: (resp: any) => {
        this.fpoBranches = resp?.data || [];
      },
      error: () => {
        this.fpoBranches = [];
      }
    });
  }


  onCustExisting(event: any) {
    console.log("in Existing---------->", event);
    this.existingCustomer = event.value;
    if (event.value == "YES") {
      this.existAcc = true;
      this.existingCustValidated = true;
      this.loanForm.controls["existingAcc"].setValidators([Validators.required]);
      this.loanForm.controls["accountNumber"].setValidators([Validators.required]);
    } else if (event.value == "NO") {
      this.existAcc = false;
      this.existingCustValidated = true
      this.disableValidation = true;
       console.log("Disbale Validation", this.disableValidation)
      this.snackbar.open("BRE conditions failed, cannot add the customer", "OK", { duration: 3000 })
      this.loanForm.controls["workAcc"].setValidators([Validators.required]);
      this.loanForm.patchValue({ salaryAccount: "NO" })
      if (this.selectedApcobLoanType == LOAN_TYPE_APCOB[0].type) {
        this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1000000)]);
        this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1000000";
      } else {

      }

    } else {
      this.existingCustValidated = false;
    }
  }

  onAccountExisting(event: any) {
    console.log("in Account---------->", event);
    if (event.value == "YES") {
      this.existCustAcc = true;
      this.existingCustAccValidated = true
      if (this.selectedApcobLoanType == LOAN_TYPE_APCOB[0].type) {
        // this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1500000)]);
        // this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1500000";
      } else {

      }
    } else if (event.value == "NO") {
      this.existCustAcc = false;
      this.existingCustAccValidated = true
      if (this.selectedApcobLoanType == LOAN_TYPE_APCOB[0].type) {
        // this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1000000)]);
        // this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1000000";
      } else {

      }
    } else {
      this.existingCustAccValidated = false;
    }

  }

  onWorkAccountExisting(event: any) {
    console.log("in Account---------->", event);
    if (event.value == "YES") {
      this.existWorkAcc = true;
      this.disableValidation = false;
      // this.existingCustAccValidated = true
      if (this.selectedApcobLoanType == LOAN_TYPE_APCOB[0].type) {
        this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1000000)]);
        this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1000000";
      } else {

      }
    } else if(event.value == "NO" && this.project != 'apex'){
      this.existWorkAcc = false;
      if (this.existAcc == false) {
        this.disableValidation = true;
        console.log("Disbale Validation", this.disableValidation)
        this.snackbar.open("BRE conditions failed, cannot add the customer", "OK", { duration: 3000 })
      } else {
        this.disableValidation = false;
      }
      // this.existingCustAccValidated = true
    } else {
      this.disableValidation = false;
      // this.existingCustAccValidated = false;
    }

  }

  onSalaryAccount(event: any) {
    console.log("in Salary Account---------->", event);
    this.selectedApcobSalaryAccount = event.value;

    if (this.selectedApcobSalaryAccount == this.yesorNo[0].type) {
      // this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1500000)]);
      // this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1500000";

    } else if (this.selectedApcobSalaryAccount == this.yesorNo[1].type) {
      // this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1000000)]);
      // this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1000000";

    }

  }

  onITRFilled(event: any) {
    console.log("in ITR Filled---------->", event);
    this.selectedApcobITR = event.value;

    if (this.selectedApcobITR == this.yesorNo[0].type) {

    } else if(this.selectedApcobITR == this.yesorNo[1].type && this.project != 'apex' && this.selectedApcobLoanType !== LOAN_TYPE_APCOB[3].type){

      let value = this.personalItr || this.sodItr || this.lreItr || this.ccItr;

      console.log("Value", value)

      value == true ? this.disableValidation = true : this.disableValidation = false;

      if (value == true) {
        this.snackbar.open("BRE conditions failed, cannot add the customer", "OK", { duration: 3000 });
      }

    }

  }

  onGuarantor(event: any) {
    console.log("in Guarantor---------->", event);
    this.selectedApcobGuarantor = event.value;

    this.selectedApcobGuarantor == this.yesorNo[0].type && this.project != 'apex' && this.guarantorRequired ? this.disableValidation = false : this.disableValidation = true;
   


    if (this.selectedApcobGuarantor == this.yesorNo[1].type && this.existingApcobStaff == false && this.guarantorRequired) {
      this.disableValidation  = true;
      this.snackbar.open("BRE conditions failed, cannot add the customer", "OK", { duration: 3000 });
    } else {
      this.disableValidation = false;
    }

  }

  onOthersTypeChange(event: any) {
    console.log("Type of Others", event);
  }

  onExistingStaff(event: any) {
    console.log("in Existing Staff---------->", event);


    if (event.value == "YES") {
      this.loanForm.patchValue({ salaryAccount: "YES" })
      this.existingApcobStaff = true;
      this.guarantorRequired = false;
       if (this.selectedApcobLoanType == LOAN_TYPE_APCOB[0].type) {
       this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(2000000)]);
        this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 2000000";
       }else {
       }
    } else {
       this.existingApcobStaff = false;
        if (this.selectedApcobLoanType == LOAN_TYPE_APCOB[0].type) {
       this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1000000)]);
        this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1000000";
        }else {

        }
      this.loanForm.controls['mortLoan'].setValidators([Validators.required]);
       this.loanForm.controls['marAmount'].setValidators([Validators.required]);
    }
  }


  onNonIndividualTypeChange(event: any) {
    console.log("in if---------->", event);
    if (event.value == this.indivORNonIndiv[0].type && (this.projectName == 'vkf'|| this.projectName == 'sahyadarifarms')) {
      this.isNonIndiviShown = false;
      // this.loanForm.get('entityType').setValidators(Validators.required);
      console.log("in else if---------->", this.selectedNonIndivType);
    // this.profileType = ENV.LOAN_CUSTOMER_TYPE.filter(type =>
    //   type.type === 'Farmer Agri' || type.type === 'Agri - Farmer'
    // );
     this.profileType = ENV.LOAN_CUSTOMER_TYPE;

    // if (!this.profileType || this.profileType.length === 0) {
    //   this.profileType = [{ type: 'Farmer Agri' }];
    // }
    this.loanForm.patchValue({ loanCustType: '', entityType: '' });
    } else if (event.value == this.indivORNonIndiv[1]?.type && this.projectName == 'vkf') {
      this.isNonIndiviShown = true;
      // this.loanForm.get('entityType').setValidators(null);
      // this.selectedNonIndivType = NONINDIVIDUAL_TYPE;
    this.selectedNonIndivType = [
      { type: 'MSME Agri' }
    ];

       this.loanForm.patchValue({ loanCustType: '', entityType: '' });

      console.log("in else if---------->", this.selectedNonIndivType);
    } else if (event.value == this.indivORNonIndiv[1]?.type &&  this.projectName == 'sahyadarifarms' ) {
      this.isNonIndiviShown = true;
    this.selectedNonIndivType = [
      { type: 'FPO' }
    ];

      console.log("in else if---------->", this.selectedNonIndivType);
    }
    // this.getCustIdForLoan()
  }


  onLoanType(event: any) {
    console.log("in Loan Type---------->", event);
     console.log("All Loan Type---------->", this.apcobLoanType);

    this.selectedApcobLoanType = event.value;

    if (event.value == LOAN_TYPE_APCOB[0].type) {
      this.subLoanTypeRequired = false;
      this.personalLoan = true;
      this.traderLoan = false;

      this.loanForm.controls['guarantor'].setValidators([Validators.required]);
      this.loanForm.controls["salaryAccount"].setValidators([Validators.required]);


      this.distanceErrMessage = `Secure property distance should not be more than 25 kms.`
      this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(25)]);

       this.loanForm.controls['itrFilled'].setValidators([Validators.required]);


      if (this.typeOfCustomer == this.profileType[1].type || this.typeOfCustomer == this.profileType[3].type || this.typeOfCustomer == this.profileType[4].type) {
        this.personalItr = true;
      } else {
        this.personalItr = false;
      }

    } else if (event.value == LOAN_TYPE_APCOB[1].type) {
      this.subLoanTypeRequired = true;
      this.personalLoan = false;
      this.traderLoan = false;
      this.subLoanType = this.apcobMortgageLoanType;
      this.loanForm.controls['loanSubType'].setValidators([Validators.required]);

      this.distanceErrMessage = `Secure property distance should not be more than 25 kms.`
      this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(25)]);

      this.loanForm.controls['itrFilled'].setValidators([Validators.required]);

      if (this.typeOfCustomer == this.profileType[0].type || this.typeOfCustomer == this.profileType[2].type) {
        this.subLoanType = MORTGAGE_LOAN_TYPE_SALPEN;
      } else {
        this.subLoanType = MORTGAGE_LOAN_TYPE;
      }

    } else if (event.value == LOAN_TYPE_APCOB[2].type && this.isProducthide == false) {
      this.subLoanTypeRequired = true;
      this.personalLoan = false;
      this.traderLoan = true;
      this.subLoanType = this.apcobTraderLoanType;
      this.loanForm.controls['loanSubType'].setValidators([Validators.required]);
      this.loanForm.controls['itrFilled'].setValidators([Validators.required]);

    } else if (event.value == LOAN_TYPE_APCOB[3].type ) {
      this.subLoanTypeRequired = true;
      this.personalLoan = false;
      // this.traderLoan = true;
      this.apcobGoldLoanType = APCOB_GOLD_LOAN_TYPE;
      this.subLoanType = this.apcobGoldLoanType;
      this.loanForm.controls['loanSubType'].setValidators([Validators.required]);

    } else {
      this.subLoanTypeRequired = false;
      this.personalLoan = false;
      this.traderLoan = false;
    }
  }


  onSubLoanType(event: any) {
    console.log("in Sub Loan Type---------->", event);
    this.selectedApcobSubLoanType = event.value;
    
    if (this.selectedApcobSubLoanType == MORTGAGE_LOAN_TYPE[0].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(2500000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 2500000";

      this.loanForm.controls['collateralSecurity'].setValidators([Validators.required]);

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);

      this.loanForm.controls['ageOfProperty'].setValidators([Validators.required,Validators.max(90)]);

      this.mlSubLoanType = this.apcobSodSubType;
      this.mortgageLoan = true;

      if (this.typeOfCustomer == this.typeOfCustomer == this.profileType[1].type || this.typeOfCustomer == this.profileType[3].type || this.typeOfCustomer == this.profileType[4].type) {
        this.sodItr = true;
      } else {
        this.sodItr = false;
      }


    } else if (this.selectedApcobSubLoanType == MORTGAGE_LOAN_TYPE[1].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(3000000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 3000000";

      this.loanForm.controls['collateralSecurity'].setValidators([Validators.required]);
      this.loanForm.controls['ageOfProperty'].setValidators([Validators.required, Validators.max(90)]);

      this.mlSubLoanType = this.apcobLarpSubType;
      this.mortgageLoan = true;
      let age = this.loanForm.get("age").value;
      let ageDiff = 840 - (age * 12);
      let tenure = 180;

       this.loanTenureErrMessage = `Loan Tenure cannot be more than ${tenure} months.`
       this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(tenure)]);
     

      console.log("age and diff", age, ageDiff);

      if (this.typeOfCustomer == this.profileType[1].type || this.typeOfCustomer == this.profileType[3].type || this.typeOfCustomer == this.profileType[4].type) {
        this.lreItr = true;
      } else {
        this.lreItr = false;
      }

    } else if (this.selectedApcobSubLoanType == MORTGAGE_LOAN_TYPE[2].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(1200000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 1200000";
      this.loanForm.controls['collateralSecurity'].setValidators([Validators.required]);
      this.loanForm.controls['ageOfProperty'].setValidators([Validators.required, Validators.max(90)]);
      this.loanTenureErrMessage = `Loan Tenure cannot be more than 120 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(120)]);

      this.mlSubLoanType = this.apcobSmlSubType;
      this.mortgageLoan = true;
    } else if (event.value == TRADER_LOAN_TYPE[0].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000), Validators.max(200000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 50000 and 200000";

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 36 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(36)]);

      this.distanceErrMessage = `Secure property distance should not be more than 5 kms.`
      this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(5)]);
      this.ssuf = true;
      this.subTraderLoanType = TRADER_LOAN_SUB_TYPE;
      this.apcobSubLoanType = "Trader";
      this.loanForm.controls['traderLoanSub'].setValidators([Validators.required]);

    } else if (this.selectedApcobSubLoanType == TRADER_LOAN_TYPE[1].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000),Validators.max(4000000)]);
      this.loanAmountErrorMessage = "Loan Amount should be more than 50000 and less than 4000000";

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);

      this.distanceErrMessage = `Secure property distance should not be more than 25 kms.`
      this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(25)]);

      if (this.typeOfCustomer == this.profileType[1].type || this.typeOfCustomer == this.profileType[3].type || this.typeOfCustomer == this.profileType[4].type) {
        this.ccItr = true;
      } else {
        this.ccItr = false;
      }

    } else if (this.selectedApcobSubLoanType == APCOB_GOLD_LOAN_TYPE[0].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(10000), Validators.max(3500000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 10000 and 3500000"; 
      // this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(25)]);
      // this.distanceErrMessage = `Secure property distance should not be more than 25 kms.`
      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);

      this.loanForm.patchValue({ tenure: 12});
      this.tenureDisable = true;

    } else if (this.selectedApcobSubLoanType == APCOB_GOLD_LOAN_TYPE[1].type || this.selectedApcobSubLoanType == APCOB_GOLD_LOAN_TYPE[2].type) {

      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(10000), Validators.max(3500000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 10000 and 3500000";  
      // this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(25)]);
      // this.distanceErrMessage = `Secure property distance should not be more than 25 kms.`
      this.loanTenureErrMessage = `Loan Tenure cannot be more than 6 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(6)]);

      this.loanForm.patchValue({ tenure: 6});
      this.tenureDisable = true;

    } else {
      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(50000)]);
      this.loanAmountErrorMessage = "Loan Amount should be more than 50000";

      this.loanTenureErrMessage = `Loan Tenure cannot be empty.`
      this.loanForm.controls['tenure'].setValidators([Validators.required]);
    }


  }

  onTraderLoan(event: any) {
    this.traderLoanSubType = event.value;

   if (this.traderLoanSubType == TRADER_LOAN_SUB_TYPE[0].type) {
      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(10000), Validators.max(300000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 10000 and 300000";
      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);
    } else if (this.traderLoanSubType == TRADER_LOAN_SUB_TYPE[1].type) {
      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(10000), Validators.max(500000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 10000 and 500000";
      let loanAmount = this.loanForm.get("loanAmount").value;
      if(loanAmount <= 200000){
          this.loanTenureErrMessage = `Loan Tenure cannot be more than 24 months.`
          this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(24)]);
      } else if(loanAmount > 200000 && loanAmount <= 300000){
          this.loanTenureErrMessage = `Loan Tenure cannot be more than 48 months.`
          this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(48)]);
      } else if(loanAmount > 300000 && loanAmount <= 500000){
          this.loanTenureErrMessage = `Loan Tenure cannot be more than 60 months.`
          this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(60)]);
      }
      
    } else {
      this.loanForm.controls['loanAmount'].setValidators([Validators.required, Validators.min(10000), Validators.max(300000)]);
      this.loanAmountErrorMessage = "Loan Amount should be between 10000 and 300000";
      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);
    }
  }


  onAgeChange(event: any) {

    let ageValue = event.value; console.log(ageValue)

    let age = this.loanForm.get("age").value;
    let ageDiff = 744 - (age * 12);
    let pensionerageDiff = 840 - (age * 12);
    let tenure = 60;

    console.log("age and diff", age, ageDiff);

    if (this.personalLoan == true) {

      if (this.typeOfCustomer == 'Pensioner' && pensionerageDiff < 60) {
        tenure = pensionerageDiff;
        console.log("tenure", tenure)
        this.loanTenureErrMessage = `Loan Tenure cannot be more than ${tenure} months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(tenure)]);
      } else if (ageDiff < 60 && !this.existingApcobStaff && this.typeOfCustomer != 'Pensioner') {
        tenure = ageDiff;
        this.loanTenureErrMessage = `Loan Tenure cannot be more than ${tenure} months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(tenure)]);
      } else if (ageDiff && this.existingApcobStaff) {
        this.loanTenureErrMessage = `Loan Tenure cannot be more than 120 months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(120)]);
      } else {
        tenure = 60;
        this.loanTenureErrMessage = `Loan Tenure cannot be more than 60 months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(60)]);
      }

      console.log("Loan tenure", tenure)
    } else if (this.selectedApcobSubLoanType == MORTGAGE_LOAN_TYPE[0].type) {

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);

    } else if (this.selectedApcobSubLoanType == MORTGAGE_LOAN_TYPE[1].type) {

      let age = this.loanForm.get("age").value;
      let ageDiff = 840 - (age * 12);
      let tenure = 180;

      if (ageDiff < tenure) {
        tenure = ageDiff;
        this.loanTenureErrMessage = `Loan Tenure cannot be more than ${tenure} months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(tenure)]);
      } else {
        this.loanTenureErrMessage = `Loan Tenure cannot be more than ${tenure} months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(tenure)]);
      }

      console.log("age and diff", age, ageDiff);

    } else if (this.selectedApcobSubLoanType == MORTGAGE_LOAN_TYPE[2].type) {

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 120 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(120)]);

    } else if (this.selectedApcobSubLoanType == TRADER_LOAN_TYPE[0].type) {

      this.distanceErrMessage = `Secure property distance should not be more than 5 kms.`
      this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(5)]);

      if (this.traderLoanSubType == TRADER_LOAN_SUB_TYPE[1].type) {
        this.loanTenureErrMessage = `Loan Tenure cannot be more than 36 months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(36)]);
      } else {
        this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
        this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);
      }

    } else if (this.selectedApcobSubLoanType == TRADER_LOAN_TYPE[1].type) {

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);

      this.distanceErrMessage = `Secure property distance should not be more than 25 kms.`
      this.loanForm.controls['propertyDist'].setValidators([Validators.required, Validators.max(25)]);


    } else if(this.selectedApcobSubLoanType == APCOB_GOLD_LOAN_TYPE[0].type) {

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 12 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(12)]);

    } else if(this.selectedApcobSubLoanType == APCOB_GOLD_LOAN_TYPE[1].type || this.selectedApcobSubLoanType == APCOB_GOLD_LOAN_TYPE[2].type) {

      this.loanTenureErrMessage = `Loan Tenure cannot be more than 6 months.`
      this.loanForm.controls['tenure'].setValidators([Validators.required, Validators.max(6)]);

    } else {
      this.loanTenureErrMessage = `Loan Tenure cannot be empty.`
      this.loanForm.controls['tenure'].setValidators([Validators.required]);
    }

  }

  onMortgageLoanChange(event: any) {
     
      let mortgageLoanChange = event.value;
      if(mortgageLoanChange == "YES"){
          this.mortgageLoanChange = true;
          this.guarantorRequired = true;
      } else {
          this.mortgageLoanChange = false;
           this.guarantorRequired = true;
      }
  }

  onMarginAmountChange(event: any) {
    let marginAmount = event.value;
    let loanAmount = this.loanForm.get("loanAmount").value;
    if(marginAmount == "YES"){
        this.guarantorRequired = false;
    }else {
        this.guarantorRequired = true;
    }
  }

  onCollateralSecurity(event: any) {
    let collateralSecurity = event.value; 
    this.collateralSecurityValue = collateralSecurity;
    if(collateralSecurity == "YES"){
        this.collateralSecurity = true;
        // this.guarantorRequired = false;
    } else {
        this.collateralSecurity = false;
        // this.guarantorRequired = true;
    }
  }

  onLoanFormSubmit() {

    if (this.projectName === 'kgb') {
      if (this.loanForms.get('name').invalid || this.loanForms.get('mobileNo').invalid) {
        this.snackbar.open("Please fill required fields", "OK", { duration: 3000 });
        return;
      }

      this.showSpinner = true;
      const kgbPayload = {
        profileId: this.loanForms.get("profileId").value,
        customerName: this.loanForms.get("name").value,
        customerEmail: this.loanForms.get("email").value,
        customerMobileNumber: this.loanForms.get("mobileNo").value,
        residenceAddress: this.loanForms.get("resAdd").value,
        officeAddress: this.loanForms.get("office").value || this.loanForms.get("offadd").value,
        applicationType: this.loanForms.get("applicationType").value,
        loanType: this.loanForms.get("loanType").value,
        addedBy: sessionStorage.getItem("adminId"),
        repName: sessionStorage.getItem("name"),
        projectName: "kgb"
      };

      this.cust.addprofilekgb(kgbPayload).subscribe(
        (resp) => {
          this.showSpinner = false;
          if (resp && resp.success) {
            this.snackbar.open("Applicant Added Successfully", "OK", { duration: 3000 });
            this.router.navigate(["/dashboard/view-customer"]);

          } else {
            this.snackbar.open(resp.message || "Failed to add applicant", "OK", { duration: 3000 });
          }
        },
        (err) => {
          this.showSpinner = false;
          this.snackbar.open("Error connecting to server", "OK", { duration: 3000 });
        }
      );
      return;
    }

    if (this.loanForm.controls['loanCustMobNum'].invalid || this.loanForm.invalid || this.disableSubmit || this.isDisableSubmit) {
      return
    }

    let entType = this.loanForm.get("entityType").value;
    if (entType == this.nonIndivType[0].type) {
      this.custType = "Proprietary";
    } else if (entType == this.nonIndivType[1].type) {
      this.custType = "Partnership";
    } else if (entType == this.nonIndivType[2].type) {
      this.custType = "LLP";
    } else if (entType == this.nonIndivType[3].type) {
      this.custType = "Private Limited";
    }


    let entityName = sessionStorage.getItem('entityName') || null;
    

    let reqObj = {
      applicationType: "Apply For Loan",

      customerName: this.loanForm.get("loanCustName").value,
      customerEmail: this.loanForm.get("loanCustEmail").value,
      customerMobileNumber: this.loanForm.get("loanCustMobNum").value * 1,

      addedBy: sessionStorage.getItem("adminId"),

      repName: sessionStorage.getItem("name"),

      profileType: this.loanForm.get("customerTypes").value,
      loanType: this.loanForm.get("entityType").value
        ? this.loanForm.get("entityType").value
        : this.loanForm.get("loanCustType").value,
      panCheck: this.loanForm.get("panNo").value,
      salesUser: "Vinod",
      "entityName": entityName || ''
    };

    if (this.projectName === 'sahyadarifarms' || this.projectName == 'Whatsloan_marketplace') {
      reqObj['branchId'] = this.loanForm.get('fpoName').value || null;
      reqObj['loanPurpose'] = "for loan of JOWER";
    }

    console.log("loanData " + JSON.stringify(reqObj));

    this.disableSubmit = false;
    this.disablePay = false;
    this.disablePayWithRazor = false;
    this.isDataPending = true;
    this.showSpinner = true;



    if (this.project == "apcob") {

      let req = {
        "profileType": "Individual",
        "loanType": this.selectedApcobLoanType || "",
        "subLoanType": this.traderLoanSubType || this.selectedApcobSubLoanType || "Personal Loan",
        "etbApcob": this.existCustAcc || false,
        "salaryAccountWithApcob": this.selectedApcobSalaryAccount == "YES" ? true : false,
        "customerAge": this.loanForm.get("age").value,
        "requiredLoanAmount": this.loanForm.get("loanAmount").value,
        "tenure": this.loanForm.get("tenure").value,
        "customerEmail": "",
        "customerName": this.loanForm.get("loanCustName").value,
        "customerMobileNumber": this.loanForm.get("loanCustMobNum").value,
        "addedBy": sessionStorage.getItem("adminId"),
        "repName": sessionStorage.getItem("name"),
        "parentProfileId": "",
        "accountNumber": this.loanForm.get("accountNumber").value,
        // "types": "", // only Guarantor or Coapplicant case sensitive
        "relation": "", //optional
        "panCheck": "", //optional
        "projectName": "APCOB",
        "securityPropertyDistance": this.loanForm.get("propertyDist").value,
        "customerType": this.loanForm.get('loanCustType').value,
        "itrAvailable": this.selectedApcobITR == "YES" ? true : false,
        "guarantorValid": this.selectedApcobGuarantor == "YES" ? true : false,
        "existingApcob": this.existAcc,
        "existingApcobStaff": this.existingApcobStaff,
        "existingMoreThan6Months": this.existCustAcc || false,
        "employerReputed": this.existWorkAcc || false,
        "isApplicant": true,
        "isGuarantor": false,
        "isCoapplicant": false,
        "guarantorsRequired":  this.guarantorRequired,
        "collateralSecurity": this.collateralSecurityValue,
        "ageOfProperty": this.loanForm.get("ageOfProperty").value,
      }

      console.log(req)

      this.cust.addApcobProfile(req).subscribe(resp => {
        console.log(" APCOB Res:", resp);
        this.showSpinner = false;
        if (resp.success) {
          this.disableSubmit = true;
          this.disablePay = true;
          this.disablePayWithRazor = false;
          this.isDataPending = false;

          if (resp.data) {

            localStorage.setItem("wl-applicant-id", resp.data?._id);
            localStorage.setItem("loan-type", resp.data?.loanType);
            this.id = resp.data?._id;

            let data = {
              applicantId: this.id,
              link: ENV.encryptRequestUrl,
              customerMobileNumber: resp?.data?.customerMobileNumber,
            };


            this.applicant.mobileConsent(data).subscribe(
              (resp) => {
                if (resp) {
                  console.log(resp);
                   this.snackbar.open(
              "Customer has been added and verification link sent Successfully",
              "OK",
              {
                duration: 2000,
              }
            );
                } else {
                  this.snackbar.open("Error sending link to customer", "OK", {
                    duration: 3000,
                  });
                }
              },
              (err) => {
                this.snackbar.open("Error sending link to customer", "OK", {
                  duration: 3000,
                });
              }
            );

          } else {
            this.snackbar.open(resp.message, "OK", { duration: 2000 });
          }

          setTimeout(
            () => window.open(ENV.frontendUrl + "dashboard", "_self"),
            1000
          );


        } else {
          this.snackbar.open(resp.message, "OK", { duration: 2000 });
        }
      }, err => {
        this.showSpinner = false;
        this.disableSubmit = false;
        this.snackbar.open("Profile cannnot be added", "OK", { duration: 2000, });
      })

    
    } else if(this.project == "apex") {
      this.cust.addProfileApex(reqObj).subscribe(
        async (res) => {
          console.log("Loan Add Res: ", res);
          this.showSpinner = false;
          if (res.success) {
            this.disableSubmit = true;
            this.disablePay = true;
            this.disablePayWithRazor = false;
            this.isDataPending = false;
            let countValue = { countvalue: "" };
            countValue.countvalue = this.countValue;
            console.log(countValue);

            if (res && res.data && res.data?.applicantId) {
              localStorage.setItem("wl-applicant-id", res.data?.applicantId);
              localStorage.setItem("loan-type", res.data?.loanType);
              this.id = res.data?.applicantId;

              let data = {
                applicantId: this.id,
                link: ENV.encryptRequestUrl,
                customerMobileNumber: res?.data?.customerMobileNumber,
              };

              if (this.project != 'dfid' && this.project != 'moneyboxx') {


                this.applicant.mobileConsent(data).subscribe(
                  (resp) => {
                    if (resp) {
                      console.log(resp);
                    } else {
                      this.snackbar.open("Error sending link to customer", "OK", {
                        duration: 3000,
                      });
                    }
                  },
                  (err) => {
                    this.snackbar.open("Error sending link to customer", "OK", {
                      duration: 3000,
                    });
                  }
                );

                this.snackbar.open(
                  "Customer has been added and verification link sent Successfully",
                  "OK",
                  {
                    duration: 2000,
                  }
                );
              } else {
                this.snackbar.open("Profile has been added Successfully", "OK",
                  {
                    duration: 2000,
                  }
                );
              }
            }

            // this.snackbar.open('Customer Added Successfully', 'OK', { duration: 2000 });
            if (sessionStorage.getItem("auth-type") != "user") {
              if (
                sessionStorage.getItem(
                  constants.PROFILE_EXISTS_PATH_SETTER_KEY
                ) == "true"
              ) {
                // do nothing as of now - maybe show profiles list or count
              } else {
                await this.login();
                this.router.navigate(["dashboard"]);
              }
            }

            console.log(this.loanForm.value);
            this.showLoanAccountForm = false;

            setTimeout(
              () => window.open(ENV.frontendUrl + "dashboard", "_self"),
              1000
            );
          } else {
            this.isDataPending = false;
            this.disableSubmit = false;
            this.disablePay = false;
            this.disablePayWithRazor = false;
            this.snackbar.open(res.message, "OK", { duration: 2000 });
            this.loanForm.disable();
          }
        },
        (err) => {
          this.showSpinner = false;
          this.disableSubmit = false;
          this.snackbar.open("Profile cannnot be added", "OK", {
            duration: 2000,
          });
        }
      );
    }
    
    
    else {
      this.cust.addProfile(reqObj).subscribe(
        async (res) => {
          console.log("Loan Add Res: ", res);
          this.showSpinner = false;
          if (res.success) {
            this.disableSubmit = true;
            this.disablePay = true;
            this.disablePayWithRazor = false;
            this.isDataPending = false;
            let countValue = { countvalue: "" };
            countValue.countvalue = this.countValue;
            console.log(countValue);

            if (res && res.data && res.data?.applicantId) {
              localStorage.setItem("wl-applicant-id", res.data?.applicantId);
              localStorage.setItem("loan-type", res.data?.loanType);
              this.id = res.data?.applicantId;

              let data = {
                applicantId: this.id,
                link: ENV.encryptRequestUrl,
                customerMobileNumber: res?.data?.customerMobileNumber,
              };

              if (this.project != 'dfid' && this.project != 'moneyboxx') {


                this.applicant.mobileConsent(data).subscribe(
                  (resp) => {
                    if (resp) {
                      console.log(resp);
                    } else {
                      this.snackbar.open("Error sending link to customer", "OK", {
                        duration: 3000,
                      });
                    }
                  },
                  (err) => {
                    this.snackbar.open("Error sending link to customer", "OK", {
                      duration: 3000,
                    });
                  }
                );

                this.snackbar.open(
                  "Customer has been added and verification link sent Successfully",
                  "OK",
                  {
                    duration: 2000,
                  }
                );
              } else {
                this.snackbar.open("Profile has been added Successfully", "OK",
                  {
                    duration: 2000,
                  }
                );
              }
            }

            // this.snackbar.open('Customer Added Successfully', 'OK', { duration: 2000 });
            if (sessionStorage.getItem("auth-type") != "user") {
              if (
                sessionStorage.getItem(
                  constants.PROFILE_EXISTS_PATH_SETTER_KEY
                ) == "true"
              ) {
                // do nothing as of now - maybe show profiles list or count
              } else {
                await this.login();
                this.router.navigate(["dashboard"]);
              }
            }

            console.log(this.loanForm.value);
            this.showLoanAccountForm = false;

            setTimeout(
              () => window.open(ENV.frontendUrl + "dashboard", "_self"),
              1000
            );
          } else {
            this.isDataPending = false;
            this.disableSubmit = false;
            this.disablePay = false;
            this.disablePayWithRazor = false;
            this.snackbar.open(res.message, "OK", { duration: 2000 });
            this.loanForm.disable();
          }
        },
        (err) => {
          this.showSpinner = false;
          this.disableSubmit = false;
          this.snackbar.open("Profile cannnot be added", "OK", {
            duration: 2000,
          });
        }
      );
    }
  }

  login() {
    sessionStorage.setItem("auth-type", "customer");
    let payload = {
      applicantId: sessionStorage.getItem("wl-applicant-id"),
      token: sessionStorage.getItem(constants.SESSION_MAINTENANCE_TOKEN_KEY),
      customerMobileNumber: sessionStorage.getItem("mobileNo"),
    };
    this.applicant.selfLogin(payload).subscribe(
      (resp) => {
        if (resp && resp.success) {
          sessionStorage.setItem(
            constants.LOGIN_TOKEN_KEY,
            resp.data && resp.data.token
          );
          sessionStorage.setItem(
            constants.CUSTOMER_INITIATED_JOURNEY_HEADER_SETTER.KEY,
            constants.CUSTOMER_INITIATED_JOURNEY_HEADER_SETTER.VALUE
          );
          sessionStorage.setItem(
            constants.SELF_OR_ASSISTED_HEADER_SETTER.KEY,
            constants.SELF_OR_ASSISTED_HEADER_SETTER.SELF_VALUE
          );
          sessionStorage.setItem(
            constants.AUTH_TYPE.KEY,
            constants.AUTH_TYPE.CUSTOMER_VALUE
          );
          let loginInfo = resp.data;
          loginInfo.roleId = 10;
          sessionStorage.setItem("loginInfo", JSON.stringify(loginInfo));
          sessionStorage.setItem("adminId", resp.data._id);
          this.router.navigate(["/dashboard"]);
        } else {
          this.snackbar.open("Login Failed", "OK");
        }
      },
      (err) => {
        this.snackbar.open(err.message, "OK");
      }
    );
  }

  validateNumber(event) {
    const keyCode = event.keyCode;

    const excludedKeys = [8, 37, 39, 46];

    if (
      !(
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 96 && keyCode <= 105) ||
        excludedKeys.includes(keyCode)
      )
    ) {
      event.preventDefault();
    }
  }

  checkPAN(event) {
    let data = {
      panCheck: this.loanForm.get("panNo").value,
      type: "pan"
    };
    this.isPanVerified = false;
    this.cust.panVerify(data).subscribe(
      (resp) => {
        console.log(resp);
        if (resp) {
          this.isPanVerified = true;
          if (resp.success) {
            this.isDisableSubmit = false;
            this.isPanAllowed = true;

            //  this.showAddCustomer = false;
            //  this.showExistingCustomerName = true;
            this.customerName = resp.name ? resp.name : "";
            this.profileId = resp.profileId ? resp.profileId : "";
            this.loanForm.patchValue({
              loanCustName: resp.name ? resp.name : "",
              loanCustEmail: resp.email ? resp.email : "",
              loanCustMobNum: resp.mobile ? resp.mobile : "",

            });

            //  this.loanForm.patchValue({"loanCustName":resp?.})
            this.snackbar.open(resp.message, "OK", { duration: 3000 });
          } else {
            // this.loanForm.disable();
            this.isPanAllowed = false;
            // this.isDisableSubmit = true;
            // this.showAddCustomer = false;
            this.snackbar.open(resp.message, "OK", { duration: 3000 });
            // this.showExistingCustomerName = true;
            // this.customerName = resp.name ? resp.name : "";
            // this.profileId = resp.profileId ? resp.profileId : "";
          }
        } else {
          this.isDisableSubmit = false;
          this.snackbar.open("Error in verifying PAN", "OK", {
            duration: 3000,
          });
        }
      },
      (err) => {
        this.isPanVerified = false;
        this.isDisableSubmit = false;
        this.snackbar.open("Error in verifying PAN", "OK", { duration: 3000 });
      }
    );
  }

  onApplicationTypeChange(event: any): void {
    const selectedType = event.value;
    this.loanForm.get('loanType')?.patchValue('');
    this.subLoanOptions = [];
    if (selectedType === 'Retail Loans') {
      this.cust.getretailLoan().subscribe(data => {
        this.subLoanOptions = data;
      });
    } else if (selectedType === 'Farmer Loans - KCC') {
      this.cust.getfarmerLoan().subscribe(data => {
        this.subLoanOptions = data;
      });
    }
  }
}
